import React, { useState } from 'react';
import {
  Box, FormControl, FormLabel, Input, Button, VStack, Heading, Textarea, Checkbox, useToast,
} from '@chakra-ui/react';
import axios from 'axios';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const BusinessForm = () => {
  const [formData, setFormData] = useState({
    member_id: '',
    business_name: '',
    business_location: '',
    address: ''
  });
  const [photoBusiness, setPhotoBusiness] = useState(null);
  const [photoOwner, setPhotoOwner] = useState(null);
  const [offersDiscount, setOffersDiscount] = useState(false);
  const [wantsPromotion, setWantsPromotion] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleTextChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleBusinessPhotoChange = (e) => setPhotoBusiness(e.target.files[0]);
  const handleOwnerPhotoChange = (e) => setPhotoOwner(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const submissionData = new FormData();
    // Append all text fields from state
    for (const key in formData) {
      submissionData.append(key, formData[key]);
    }
    // Append files and checkboxes
    if (photoBusiness) submissionData.append('photo_business', photoBusiness);
    if (photoOwner) submissionData.append('photo_owner', photoOwner);
    submissionData.append('offers_discount', offersDiscount);
    submissionData.append('wants_promotion', wantsPromotion);

    try {
      await axios.post(`${API_BASE_URL}/api/business/create`, submissionData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast({ title: 'Profile Submitted.', description: 'Your business profile is pending review.', status: 'success' });
    } catch (error) {
      toast({ title: 'Submission Failed.', description: error.response?.data?.message, status: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box p={8} maxWidth="800px" borderWidth={1} borderRadius={8} boxShadow="lg" mx="auto" my={10}>
      <VStack as="form" spacing={4} onSubmit={handleSubmit}>
        <Heading>Create Your Business Profile</Heading>
        <FormControl isRequired>
            <FormLabel>Your Member ID</FormLabel>
            <Input name="member_id" onChange={handleTextChange} />
        </FormControl>
        <FormControl isRequired>
            <FormLabel>Business Name</FormLabel>
            {/* Ensure the name attribute is exactly "business_name" */}
            <Input name="business_name" onChange={handleTextChange} />
        </FormControl>
        <FormControl isRequired><FormLabel>Business Location (City/Area)</FormLabel><Input name="business_location" onChange={handleTextChange} /></FormControl>
        <FormControl isRequired><FormLabel>Full Address</FormLabel><Textarea name="address" onChange={handleTextChange} /></FormControl>
        <FormControl><FormLabel>Photo of Business/Shop</FormLabel><Input type="file" p={1.5} onChange={handleBusinessPhotoChange} /></FormControl>
        <FormControl><FormLabel>Photo of Owner</FormLabel><Input type="file" p={1.5} onChange={handleOwnerPhotoChange} /></FormControl>
        <Checkbox isChecked={offersDiscount} onChange={(e) => setOffersDiscount(e.target.checked)}>Interested in giving discounts to other members?</Checkbox>
        <Checkbox isChecked={wantsPromotion} onChange={(e) => setWantsPromotion(e.target.checked)}>Interested in getting promoted on the website?</Checkbox>
        <Button type="submit" colorScheme="brand" width="full" mt={4} isLoading={isLoading}>Submit for Review</Button>
      </VStack>
    </Box>
  );
};

export default BusinessForm;